import {
  createComponentPreviewMapperModel,
  withCompInfo,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type { IPopupContainerStateRefsValues } from '../PopupContainer.types';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type { PopupContainerProps as PopupContainerPlatformProps } from '@wix/thunderbolt-components';

export const props = withCompInfo<any, any, PopupContainerPlatformProps>()(
  ['experiments'],
  ({ experiments }, carmiData) => {
    const isDisableDocumentScrollWhenLightBoxOpenExperimentOpen =
      isExperimentOpen(
        experiments,
        'specs.thunderbolt.DisableDocumentScrollWhenLightBoxOpen',
      );

    return {
      ...carmiData,
      isDisableDocumentScrollWhenLightBoxOpenExperimentOpen,
    };
  },
);

export const stateRefs = withStateRefsValues<
  keyof IPopupContainerStateRefsValues
>(['pageId', 'setSiteScrollingBlocked']);

export default createComponentPreviewMapperModel({ props, stateRefs });
